const UserActionTypes = {
  LOGIN: "user/login",
  LOGOUT: "user/logout",
};

export default UserActionTypes;
